


import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { ServicePathsSettings } from '../../../../core/configuration/service-paths-settings';
import { DocumentoAllegato } from '../../../models/documento-allegato';
import { ProtocolService } from '../../../protocol/services/protocol.service';
import { RequestProtocol } from 'src/app/common/protocol/models/dto/request-fascicolo-protocol';
import { ResponseDocumentProtocol } from 'src/app/common/protocol/models/dto/response-document-protocol';
import { ProtocolFascicoloInsertComponent } from 'src/app/common/protocol/components/fascicolo/insert/protocol-fascicolo-insert.component';

  declare var closeModal: any;
  declare var openModal: any;

  @Component({
    selector: 'div [doc_protocol_modal]',
    templateUrl: './protocolla-documento-modal.component.html',
    host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
  })
  export class ProtocollaDocumentoModalComponent  {
    constructor( private protocolservice:ProtocolService){}
    @Output() onReturn = new EventEmitter();
    @ViewChild('protocol') protocol: ProtocolFascicoloInsertComponent;
    documento: DocumentoAllegato;
    listaDocumenti: DocumentoAllegato[] = [];
    idFascicolo: string;
    initForm(documento: DocumentoAllegato,idFascicolo:string, listaDocumenti?: DocumentoAllegato[]) {
      this.documento = documento;
      this.listaDocumenti = listaDocumenti;
      this.idFascicolo = idFascicolo;
      this.protocol.formProtocol.reset();
      openModal('docProtocolModal');
    }


    getUrlUploadNewVersionDocumento() {
      return ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_UPLOAD_NEW_VERSION_DOCUMENTO;
    }

    onInsert(protocol: RequestProtocol) {
      this.protocolservice.protocolDocument(protocol,this.idFascicolo).subscribe(res => {
        this.documento.numeroProtocollo = res.metadata.sigla + '/' + res.metadata.protocolYear + '/' + res.metadata.protocolNumber;
        this.documento.dataProtocollazione = this.convertDateStringToTimestamp(res.metadata.creatAt);
        this.documento.senderReceiver = res.metadata.senderReceiver;
        this.documento.oggettoProtocollo = res.metadata.subject;
        this.documento.inUscita = res.metadata.tipoReg == 'In uscita';
        this.documento.flagAllegatoPrincipale = true;
        let docProtocol:ResponseDocumentProtocol={document:this.documento, dossierNumber:res.metadata.dossierNumber, protocolNumber:res.metadata.protocolNumber}
        this.onReturn.emit(docProtocol);
        closeModal('docProtocolModal');
      });
    }

    convertDateStringToTimestamp(dateString: string): number {
      if (!dateString) {
        return 0;
      }

      const [datePart, timePart] = dateString.split(' ');
      const [day, month, year] = datePart.split('/');
      const formattedDate = `${year}-${month}-${day} ${timePart}`;

      return new Date(formattedDate).getTime();
    }

  }

